import styled from "styled-components";
import { 
  Form as AntForm,
  Typography as AntTypography, 
} from "antd";
import { BackArrow } from '@assets';
import { AuthBg, AuthLogo } from "@assets/auth";
import lightTheme from '@styles/theme';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }

  #login-btn {
    margin-bottom: 30px;
  }
`;


export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 25px;
  height: 25px;
`;

export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`

export const Title = styled(AntTypography.Title)`
  text-align: center;
  color: #FFC654 !important;
  text-align: center;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
` 

export const Form = styled(AntForm)`
  margin-top: 50px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item:last-child {
    margin-bottom: 0 !important;
  }

  .ant-form-item-label {
    margin-left: 8px;
    margin: 0px 0 2px 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 100;
    line-height: normal;
  }

  .ant-input-affix-wrapper {
    height: 56px;
    border-radius: 12px;

    input {
      height: auto !important;
      text-align: center;
    }
  }

  .ant-input-affix-wrapper:hover{
    border: 2px solid #FFC654;
  }

  input {
    height: 56px;
    border: 1px solid #e1cce0;
    border-radius: 12px;
  }
  
  .ant-btn-primary {
    height: 56px;
  }
`;

